// @ts-nocheck
import React from 'react';
import styled from 'styled-components';
import CopyButton from 'aegisv2/CopyButton';
import Crehanaicons172 from 'crehana-icons/Crehanaicons172';
import Crehanaicons170 from 'crehana-icons/Crehanaicons170';
import Crehanaicons173 from 'crehana-icons/Crehanaicons173';
import { EVENTS } from 'Jsx/ResourceDetail/constants';

type LinkProps = {
  show: boolean;
};

const Links = styled.div<LinkProps>`
  display: flex;
  align-items: center;
  width: 220px;
  justify-content: space-between;
  margin-bottom: 20px;
  @media (min-width: 1024px) {
    opacity: ${({ show }) => (show ? '1' : '0')};
    transition: all ease 0.3s;
    flex-direction: column;
    width: 50px;
    height: 220px;
    justify-content: space-between;
  }
`;

const FacebookIcon = styled.div`
  color: #3b5998;
  cursor: pointer;
`;

const TwitterIcon = styled.div`
  color: #00aced;
  cursor: pointer;
`;

const LinkedinIcon = styled.div`
  color: #0d85be;
  cursor: pointer;
`;

const CopyButtonWrapper = styled.div`
  width: 40px;
  height: 40px;
  border: 1px solid #dfe1e6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    margin-right: 0px !important;
    height: 18px;
    width: 18px;
  }
  > div > div {
    top: -60px;
    right: -30px;
    > div:nth-child(1) {
      width: 100px;
    }
  }
`;

const ShareBlock = ({ category }) => {
  const [hideShare, setHideShare] = React.useState(false);

  const data = {
    twitter: window.data.share_links.twitter,
    facebook: window.data.share_links.facebook,
    linkedin: window.data.share_links.linkedin,
  };

  const handleShare = (currentCategory: string, social: string) => {
    window.open(data[social], '_blank', 'width=600, height=350');
  };

  const handleScroll = () => {
    if (window.scrollY + 2000 > document.body.scrollHeight) {
      setHideShare(true);
    } else {
      setHideShare(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  return (
    <Links show={!hideShare}>
      <FacebookIcon onClick={() => handleShare(category, 'facebook')}>
        <Crehanaicons172 color="#3b5998" size={40} />
      </FacebookIcon>
      <TwitterIcon onClick={() => handleShare(category, 'twitter')}>
        <Crehanaicons170 color="#00aced" size={40} />
      </TwitterIcon>
      <LinkedinIcon onClick={() => handleShare(category, 'linkedin')}>
        <Crehanaicons173 color="#0d85be" size={40} />
      </LinkedinIcon>
      <CopyButtonWrapper>
        <CopyButton textToCopy={window.location.href} />
      </CopyButtonWrapper>
    </Links>
  );
};

export default ShareBlock;
